export default function Phonetics(props) {
  if (props.Phonetics) {
    return props.Phonetics;
  } else {
    return null;
  }
}
